import { createContext } from "react"

const AccessHoursContext = createContext();

export default AccessHoursContext;